import { proxy } from 'valtio';

type SiteData = {
  siteId: string | undefined;
};

export const currentSiteData = proxy<SiteData>({
  siteId: undefined,
});

export const updateSiteId = (id: string) => (currentSiteData.siteId = id);
